import { render, staticRenderFns } from "./editBanner.vue?vue&type=template&id=5a0f524e&scoped=true&"
import script from "./editBanner.vue?vue&type=script&lang=js&"
export * from "./editBanner.vue?vue&type=script&lang=js&"
import style0 from "./editBanner.vue?vue&type=style&index=0&id=5a0f524e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0f524e",
  null
  
)

export default component.exports